import { render } from "./NavbarInventory.vue?vue&type=template&id=5fae805e&scoped=true"
import script from "./NavbarInventory.vue?vue&type=script&lang=js"
export * from "./NavbarInventory.vue?vue&type=script&lang=js"

import "./NavbarInventory.vue?vue&type=style&index=0&id=5fae805e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fae805e"]])

export default __exports__